import { render, staticRenderFns } from "./CompradorForm.vue?vue&type=template&id=1e53cb4b&"
import script from "./CompradorForm.vue?vue&type=script&lang=js&"
export * from "./CompradorForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports